import React, { useState, useEffect } from "react";
import BASE_URL from "../../config";
import { useNavigate } from "react-router-dom";
export default function AboutUs() {
  const [about, setAbout] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    getAbout();

    const interval = setInterval(() => {
      getAbout();
    }, 5000); // refresh every 5 sec

    return () => clearInterval(interval);
  }, []);

  const getAbout = () => {
    fetch(`${BASE_URL}/api/getAbout.php`, {
      cache: "no-store",
    })
      .then((res) => res.json())
      .then((data) => setAbout(data))
      .catch((err) => console.error("Error:", err));
  };
  const [team, setTeam] = useState([]);

  useEffect(() => {
    getTeam();

    const interval = setInterval(() => {
      getTeam();
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const getTeam = () => {
    fetch(`${BASE_URL}/api/getTeam.php?t=${Date.now()}`)
      .then((res) => res.json())
      .then((data) => setTeam(data))
      .catch((err) => console.error("Error:", err));
  };

  const [activePlan, setActivePlan] = useState("bachat");

  return (
    <div className="about-page">
      <div className="about-hero">
        {/* LEFT: Static Home Page Content */}

        <div className="about-text">
          <div className="trust-header1">
            <span className="trust-tag1">About US</span>

            <h2>અમારા વિશે</h2>
          </div>
          {/* <div className="membership-title">
            <h2>અમારા વિશે</h2>
          </div> */}

          <h4>સંસ્થાનો પરિચય</h4>
          <p>
            શ્રી ગૃહલક્ષ્મી અર્બન કો.ઓપ. થ્રીફ્ટ, ક્રેડિટ એન્ડ કન્ઝયુમર સોસાયટી
            લિ. એ માત્ર એક નાણાકીય સંસ્થા નથી, પરંતુ મહિલાઓના આર્થિક
            સશક્તિકરણનું એક માધ્યમ છે. અમારી સંસ્થાનો મુખ્ય ઉદ્દેશ્ય મહિલાઓમાં
            બચતની વૃત્તિ કેળવવી અને તેમને આર્થિક રીતે પગભર થવા માટે સરળ ધિરાણ
            પૂરું પાડવાનો છે. સહકાર અને વિશ્વાસના પાયા પર બનેલી આ સોસાયટી
            વર્ષોથી મહિલાઓના ઉત્થાન માટે કાર્યરત છે.
          </p>
          <div className="row">
            <div className="col-md-6">
              <h4>અમારો ઉદ્દેશ </h4>
              <ul>
                <li>સભાસદો ને રોકાણ અને બચત માટે પ્રોત્સાહિત કરવા.</li>
                <li>સભાસદો ના રોકાણ પાર મહત્તમ વળતર.</li>
                <li>
                  અમારી સોસાયટી સભાસદો ને આર્થિક રીતે મજબૂત બનાવવા માટે લોન તેમજ
                  વીમા સુવિધા પુરી પડે છે.
                </li>
              </ul>
            </div>
            <div className="col-md-6">
              {" "}
              <h4>અમારું ધ્યેય </h4>
              <ul>
                <li>
                  આર્થિક જરૂરિયાત ધરાવતા લોકો અને બચત કરનારા લોકો વચ્ચે સુમેળ
                  કરાવવો.
                </li>
                <li>ગુજરાત ની નામાંકિત સહકારી સંસ્થા બનાવવી .</li>
              </ul>
            </div>
          </div>
        </div>

        {/* RIGHT: Dynamic About Image */}

        <div className="about-image">
          <img
            src={
              about?.image
                ? `${BASE_URL}/uploads/${about.image}`
                : "images/2.jpeg"
            }
            alt="about"
          />
        </div>
      </div>

      {/* HISTORY & FOUNDATION */}
      <div className="later-topics">
        <div>
          <h2>સંસ્થાનો ઇતિહાસ અને સ્થાપના</h2>
          <h4>"સહકારથી સમૃદ્ધિ તરફ – ૧૯૯૯ થી કાર્યરત"</h4>
          <p>
            શ્રી ગૃહલક્ષ્મી અર્બન કો.ઓપ. થ્રીફ્ટ, ક્રેડિટ એન્ડ કન્ઝયુમર સોસાયટી
            લિ. ની સ્થાપના વર્ષ ૧૯૯૯ માં કરવામાં આવી હતી. છેલ્લા એક દાયકાથી પણ
            વધુ સમયથી અમારી સંસ્થા મહિલાઓને આર્થિક રીતે સક્ષમ અને આત્મનિર્ભર
            બનાવવાના મિશન સાથે કાર્ય કરી રહી છે.
          </p>
          <p>
            શરૂઆતમાં એક નાનકડા હેતુ સાથે સ્થપાયેલી આ સોસાયટી આજે હજારો મહિલા
            સભાસદોનો વિશ્વાસ જીતી ચૂકી છે. ૧૯૯૯ થી અત્યાર સુધીની અમારી સફર
            પારદર્શિતા, સુરક્ષા અને મહિલા ઉત્થાનના મજબૂત પાયા પર ટકેલી છે.
          </p>
        </div>
        <div>
          <h2>અમારો અનુભવ અને સિદ્ધિઓ</h2>
          <ul>
            <li>
              <strong>૨૮ વર્ષનો અનુભવ:</strong> ૧૯૯૯ થી સતત બેંકિંગ અને ધિરાણ
              ક્ષેત્રે બહેનોને શ્રેષ્ઠ સેવા પૂરી પાડી રહ્યા છીએ.
            </li>
            <li>
              <strong>વિશ્વાસનું પ્રતીક</strong>: સ્થાપના કાળથી જ અમે સભાસદોની
              મૂડીની સુરક્ષા અને યોગ્ય વળતરને પ્રાધાન્ય આપ્યું છે.
            </li>
            <li>
              <strong>મહિલા સશક્તિકરણ:</strong> છેલ્લા 28 વર્ષમાં અનેક મહિલાઓને
              પોતાનો નાનો વ્યવસાય શરૂ કરવા માટે આર્થિક ટેકો પૂરો પાડ્યો છે.
            </li>
          </ul>
        </div>
      </div>

      {/* EXPERIENCE & MILESTONES, VISION & MISSION, GIFTS & APPRECIATION */}
      <div className="later-topics">
        {/* EXPERIENCE & MILESTONES */}

        {/* VISION & MISSION */}
        <div>
          <h2>વિઝન અને મિશન</h2>
          <ul>
            <li>
              <strong>મિશન:</strong> ૧૯૯૯ માં જે ઉદ્દેશ્ય સાથે શરૂઆત કરી હતી, તે
              મુજબ દરેક ગૃહિણી અને કામકાજી મહિલાને કરકસર અને બચત દ્વારા આર્થિક
              રીતે મજબૂત બનાવવી.
            </li>
            <li>
              <strong>વિઝન:</strong> ટેકનોલોજી અને સહકારના સમન્વયથી આગામી
              વર્ષોમાં રાજ્યની અગ્રણી મહિલા ક્રેડિટ સોસાયટી બનવું.
            </li>
          </ul>
        </div>

        {/* GIFTS & APPRECIATION */}
        <div>
          <h2>સભાસદોને પ્રોત્સાહક ભેટ</h2>
          <ul>
            <li>
              દિવાળી કે વાર્ષિક ભેટ: દર વર્ષે વાર્ષિક સભા દરમિયાન અથવા તહેવારોના
              સમયે સભાસદોને ઉપયોગી વસ્તુઓ ભેટ (Gifts) તરીકે આપવામાં આવે છે.
            </li>
            <li>
              શૈક્ષણિક પુરસ્કાર: સભાસદોના તેજસ્વી સંતાનોને શૈક્ષણિક પ્રોત્સાહન
              ઇનામો આપવામાં આવે છે.
            </li>
          </ul>
        </div>
      </div>

      <div className="trust-section">
        <div className="trust-header">
          <span className="trust-tag">WHY CHOOSE US</span>

          <h2>અમને કેમ પસંદ કરશો?</h2>

          <p>
            વિશ્વાસ, સુરક્ષા અને પારદર્શક સેવાઓ સાથે મહિલાઓ માટે ખાસ બનાવેલ
            સહકારી સંસ્થા.
          </p>
        </div>

        <div className="modern-container">
          <div className="modern-card">
            <div className="icon">
              <i className="bi bi-check-circle"></i>
            </div>
            <h4>પારદર્શક વહીવટ</h4>
            <p>સંપૂર્ણ પારદર્શક અને કાયદેસરની કામગીરી.</p>
          </div>

          <div className="modern-card">
            <div className="icon">
              <i className="bi bi-people"></i>
            </div>
            <h4>મહિલા સંચાલિત</h4>
            <p>મહિલાઓ દ્વારા, મહિલાઓ માટે અને મહિલાઓનું સંગઠન.</p>
          </div>

          <div className="modern-card">
            <div className="icon">
              <i className="bi bi-lightning"></i>
            </div>
            <h4>આકર્ષક વ્યાજ દર</h4>
            <p>થાપણો પર વધુ વ્યાજ અને લોન પર વ્યાજબી દર.</p>
          </div>

          <div className="modern-card">
            <div className="icon">
              <i className="bi bi-shield-lock"></i>
            </div>
            <h4>સરળ પ્રક્રિયા</h4>
            <p>લોન અને ખાતા ખોલાવવા માટેની ન્યૂનતમ દસ્તાવેજી પ્રક્રિયા.</p>
          </div>
        </div>
      </div>

      {/* SERVICES */}
      {/* SERVICES */}

      <div className="plan-detail">
        <div className="membership-title">
          <h2 style={{ marginBottom: "40px" }}>અમારી સેવાઓ</h2>
        </div>

        <div className="zigzag-wrapper">
          {/* ===================== BACHAT ===================== */}
          <div className="zigzag-row1" id="bachat">
            <div className="saving-family">
              <img src="/images/bachat123.jpg" alt="Saving Family" />
            </div>
            <div className="saving-family">
              <img src="/images/bachat12.jpg" alt="Saving Family" />
            </div>
          </div>

          {/* ===================== LOAN ===================== */}

          <div className="zigzag-row loan-poster" id="fd">
            <div className="row">
              <div className="col-md-6">
                <div className="zigzag-image12">
                  <img src="/images/fd1.png" alt="" />
                </div>
              </div>
              <div className="col-md-6 col">
                <div className="mar">
                  <div className="zigzag-tag">Fixed Deposit</div>
                  <div className="poster-title">❖ ફિક્સ ડિપોઝિટ યોજના ❖</div>
                  <div className="deposit-plans-wrap">
                    <div className="row g-4">
                      <div className="col-md-6">
                        <div className="deposit-card plan-one">
                          <div className="rate-badge">1 Year</div>
                          <h2>7.5%</h2>
                          <p>વાર્ષિક વ્યાજ દર</p>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="deposit-card plan-two">
                          <div className="rate-badge">2 Year</div>
                          <h2>8.5%</h2>
                          <p>વાર્ષિક વ્યાજ દર</p>
                        </div>
                      </div>
                    </div>

                    <div className="special-offer gift-card">
                      <div className="offer-icon">
                        <i className="fa fa-gift"></i>
                      </div>

                      <div>
                        <h3>૩ વર્ષ માટે ૯.૫%</h3>
                        <p>₹25,000/- કે તેથી વધુ ની રકમ પર આકર્ષક ફ્રી ગિફ્ટ</p>
                      </div>
                    </div>

                    <div className="special-offer double-money">
                      <div className="offer-icon">
                        <i className="fa fa-coins"></i>
                      </div>

                      <div>
                        <h3>8 વર્ષે બમણાં</h3>
                        <p>₹5,000/- કે તેથી વધુ ની રકમ પર આકર્ષક ફ્રી ગિફ્ટ</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* ===================== INSURANCE ===================== */}

          <div className="zigzag-row loan-poster" id="insurance">
            <div className="row">
              <div className="col-md-8">
                {" "}
                <div>
                  <div className="zigzag-tag">Insurance Plan</div>
                  <div className="poster-title">❖ વીમા યોજના ❖</div>

                  <h5
                    style={{
                      fontWeight: "600",
                      fontSize: "20px",
                      color: "#e24118",
                    }}
                  >
                    તા. ૦૧/૦૪/૨૦૨૩ થી શ્રી ગૃહલક્ષ્મી સુરક્ષા કવચ વીમા યોજના
                    ₹૨,૦૦,૦૦૦/- સંપૂર્ણપણે ચાલુ છે.
                  </h5>
                  <h5
                    style={{
                      fontWeight: "600",
                      fontSize: "20px",
                      color: "#589167",
                    }}
                  >
                    વીમાયોજનામાં જોડનાર દરેક સભાસદને ફ્રી ગિફ્ટ નો લાભ મળશે.
                  </h5>
                  <ul className="zigzag-list">
                    <li>
                      ઘણા સમયથી સભાસદ ભાઈઓ તથા બહેનોના સતત આગ્રહ અને માંગણીને
                      ધ્યાનમાં રાખીને તા: ૦૧/૦૯/૨૦૨૫ થી “શ્રી ગૃહલક્ષ્મી સુરક્ષા
                      કવચ” વીમા યોજના રૂ. ૩,૦૦,૦૦૦/- (ત્રણ લાખ) શરુ કરવા જઈ
                      રહ્યા છીએ, તેના અનુસંધાને તા: ૦૧/૦૯/૨૦૨૫ થી કુલ ૧૦૦૦ વીમા
                      યોજનાના સભાસદ થયેથી યોજના શરુ થશે.
                    </li>
                    <li>
                      તા: ૦૧/૦૪/૨૦૨૩ થી “ શ્રી ગૃહલક્ષ્મી સુરક્ષા કવચ” વીમા
                      યોજના રૂ. ૨,૦૦,૦૦૦/- (બે લાખ) સંપૂર્ણપણે ચાલુ છે.
                    </li>

                    <li>
                      રૂ. ૩,૦૦,૦૦૦/- ની વીમા યોજનાનો અમલ શરૂ ન થાય ત્યાં સુધી
                      રૂ. ૨,૦૦,૦૦૦/- નો વીમો તો મળવાપાત્ર છે જ.
                    </li>

                    <li>
                      રૂ. ૨,૦૦,૦૦૦/- (બે લાખ) વીમાયોજનામાં જે ચાલુ સભાસદો છે
                      તેમણે ફક્ત 3650/- (નોન રિફંડેબલ) ભર્યે થી નવી યોજના
                      3,00,000/- માં જોડાઈ ને વીમા નો લાભ મળવા પાત્ર બનશે.
                    </li>

                    <li>
                      18 થી 55 વર્ષ સુધીનાં સભાસદ વીમા યોજના માં જોડાય શકશે,
                      તેમજ જ્યાં સુધી સભાસદ તરીકે ચાલુ રહેશે ત્યાં સુધી વીમો
                      મળવાપાત્ર છે.
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-4">
                {" "}
                <div
                  className="zigzag-image1 col4"
                  style={{ marginTop: "60px", marginBottom: "10px" }}
                >
                  <img src="/images/vima.png" alt="" />
                </div>
              </div>
              <div className="col-md-12">
                <ul className="zigzag-list">
                  <li>
                    સદર મંડળીમાં વીમા યોજનામાં જોડાયેલા સભાસદે પ્રથમવાર વીમો
                    કરાવતી વખતે ફક્ત એક વખત રૂ. 8650/- વીમા યોજના ફી ભરવાની
                    રહેશે. જે કોઈપણ સંજોગોમાં પરત મળવાપાત્ર નથી
                  </li>

                  <li>
                    વીમાદાર સભાસદ ના ખાતા માંથી સભાસદ દીઠ કોઈપણ વ્યક્તિ નું
                    મૃત્યુ થાય તે સમયે જે રકમ મંડળી દ્વારા નક્કી કરવામાં આવે તે
                    તેના ફરજીયાત રકમ ના ખાતામાંથી ઉધારવા માં આવશે.
                  </li>

                  <li>
                    સભાસદ થયા બાદ તરત જ ફરજીયાત બચતના ખાતા માંથી વીમા સહાય માટે
                    જે રકમ કપાયેલી હોય તે દર વર્ષે એપ્રિલ માં ફરજીયાત બચતની સાથે
                    જ ફરજીયાત જમા કરાવવાની રહેશે.
                  </li>

                  <li>
                    જે વીમાદાર સભાસદની ફરજીયાત બચત+વીમાપેટે કપાયેલી રકમ જમા
                    કરવાની બાકી હશે તો તે વીમો માન્ય ગણાશે નહી.
                  </li>

                  <li>
                    કોઈપણ વીમેદાર સભાસદ નું મૃત્યુ થશે તો સભાસદ ની ફરજીયાત બચત
                    બાકી હોય તો તે ભરેલી હોવી જોઈએ.
                  </li>

                  <li>
                    કોઈપણ લોન લેનાર સભાસદમાં જામીન થયેલા હશો, તે બાબત ક્લિયર ના
                    થાય ત્યાં સુધી પાકતી વિમાની રકમ અટકાવવામાં આવશે.
                  </li>

                  <li>
                    વીમાદાર વ્યક્તિ જે લોન લેનાર સભાસદમાં જામીન થયેલા હશે, જે
                    રેગ્યુલર સભાસદ હશે તો યોગ્ય બાબત વિચારી યોગ્ય કરવામાં આવશે.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* ================= LOAN FACILITY ================= */}

          <div className="loan-section" id="loan">
            <div className="poster-title">❖ લોન સુવિધા ❖</div>

            {/* PERSONAL LOAN */}
            <div className="loan-row">
              <div className="loan-left">
                <div className="loan-icon blue">
                  <i className="fa-solid fa-user"></i>
                </div>

                <div>
                  <h3>Personal Loan</h3>
                  <h5>(જાત જામીનગીરી લોન)</h5>

                  <span className="amount-badge">2,00,000/- સુધી લોન</span>
                </div>
              </div>

              <div className="loan-features">
                <div className="loan-feature blue1">
                  <i className="fa-solid fa-indian-rupee-sign"></i>
                  <p>ઝડપી મંજૂરી</p>
                </div>

                <div className="loan-feature blue1">
                  <i className="fa-regular fa-clock"></i>
                  <p>ઓછી કાર્યવાહી</p>
                </div>

                <div className="loan-feature blue1">
                  <i className="fa-solid fa-shield-halved"></i>
                  <p>જાત જામીનગીરી લોન</p>
                </div>
              </div>

              <div className="loan-rate blue-rate blue1">
                <span>વ્યાજ દર</span>
                <h2 style={{ marginBottom: "5px" }}>18%</h2>
              </div>

              <div className="loan-image">
                <img src="images/personalloan1.png" alt="" />
              </div>
            </div>

            {/* GOLD LOAN */}

            <div className="loan-row">
              <div className="loan-left">
                <div className="loan-icon gold">
                  <i className="fa-solid fa-coins"></i>
                </div>

                <div>
                  <h3>Gold Loan</h3>
                  <h5>(ગોલ્ડ લોન)</h5>
                </div>
              </div>

              <div className="loan-features">
                <div className="loan-feature gold1">
                  <i className="fa-solid fa-hand-holding-dollar"></i>
                  <p>સોનાના આધાર પર લોન</p>
                </div>

                <div className="loan-feature gold1">
                  <i className="fa-solid fa-percent"></i>
                  <p>આકર્ષક વ્યાજ દર</p>
                </div>

                <div className="loan-feature gold1">
                  <i className="fa-solid fa-shield-halved"></i>
                  <p>સુરક્ષિત અને વિશ્વસનીય</p>
                </div>
              </div>

              <div className="loan-rate gold-rate">
                <span>વ્યાજ દર</span>
                <h2 style={{ marginBottom: "5px" }}>18%</h2>
              </div>

              <div className="loan-image">
                <img src="images/gold.png" alt="" />
              </div>
            </div>

            {/* PROPERTY LOAN */}

            <div className="loan-row">
              <div className="loan-left">
                <div className="loan-icon green">
                  <i className="fa-solid fa-house"></i>
                </div>

                <div>
                  <h3>Property Loan</h3>
                  <h5>(મિલકતના તારણ પર લોન)</h5>

                  <span className="amount-badge">
                    30,00,000/- (ત્રીસ લાખ) સુધી
                  </span>
                </div>
              </div>

              <div className="loan-features">
                <div className="loan-feature green1">
                  <i className="fa-solid fa-building"></i>
                  <p>વધુ રકમની લોન</p>
                </div>

                <div className="loan-feature green1">
                  <i className="fa-solid fa-percent"></i>
                  <p>આકર્ષક વ્યાજ દર</p>
                </div>

                <div className="loan-feature green1">
                  <i className="fa-solid fa-circle-check"></i>

                  <p>હપ્તા ની સંખ્યા</p>
                  <h2
                    style={{
                      fontSize: "20px",
                      marginBottom: "5px",
                      fontWeight: "bold",
                    }}
                  >
                    120
                  </h2>
                </div>
              </div>

              <div className="loan-rate property-rate">
                <span>વ્યાજ દર</span>
                <h2 style={{ marginBottom: "5px" }}>18%</h2>
              </div>

              <div className="loan-image">
                <img src="images/homeloan.avif" alt="" />
              </div>
            </div>

            {/* CONSUMER LOAN */}

            <div className="loan-row">
              <div className="loan-left">
                <div className="loan-icon purple">
                  <i className="fa-solid fa-cart-shopping"></i>
                </div>

                <div>
                  <h3>Consumer Loan</h3>
                  <h5>(અનાજ ધિરાણ)</h5>

                  <span className="amount-badge ">
                    25,000/- (પચ્ચીસ હજાર ) સુધી
                  </span>
                </div>
              </div>

              <div className="loan-features">
                <div className="loan-feature purple1">
                  <i className="fa-regular fa-calendar"></i>
                  {/* <p>દર વર્ષે 12 માસનું શોપિંગ</p> */}
                  <p>
                    {" "}
                    દર વર્ષે સભાસદો માટે 12 માસનું અનાજ, કરિયાણું વગેરે એક સાથે
                    ભરવા માટે 25,000/- સુધીની તુરંત જ લોન
                  </p>
                </div>

                <div className="loan-feature purple1">
                  <i className="fa-solid fa-percent"></i>
                  <p>આકર્ષક વ્યાજ દર</p>
                </div>

                <div className="loan-feature purple1">
                  <i className="fa-solid fa-circle-check"></i>

                  <p>હપ્તા ની સંખ્યા</p>
                  <h2
                    style={{
                      fontSize: "20px",
                      marginBottom: "5px",
                      fontWeight: "bold",
                    }}
                  >
                    10
                  </h2>
                </div>
              </div>

              <div className="loan-rate consumer-rate">
                {/* <div className="consumer-special">
                  દર વર્ષે સભાસદો માટે 12 માસનું અનાજ, કરિયાણું વગેરે એક સાથે
                  ભરવા માટે 25,000/- સુધીની તુરંત જ લોન
                </div> */}
                <span>વ્યાજ દર</span>
                <h2 style={{ marginBottom: "5px" }}>10%</h2>
              </div>

              <div className="loan-image">
                <img src="images/consumerloan.png" alt="" />
              </div>
            </div>

            {/* VEHICLE LOAN */}

            <div className="loan-row">
              <div className="loan-left">
                <div className="loan-icon cyan">
                  <i className="fa-solid fa-car"></i>
                </div>

                <div>
                  <h3>Vehicle loan</h3>
                  <h5>(સાધન ધિરાણ)</h5>

                  <span className="amount-badge">
                    5,00,000/- (પાંચ લાખ) સુધી
                  </span>
                </div>
              </div>

              <div className="loan-features">
                <div className="loan-feature cyan1">
                  <i className="fa-solid fa-car-side"></i>
                  <p>નવી અને જૂની બંને વાહન માટે</p>
                </div>

                <div className="loan-feature cyan1">
                  <i className="fa-solid fa-percent"></i>
                  <p>ઓછી ડાઉન પેમેન્ટ</p>
                </div>

                <div className="loan-feature cyan1">
                  <i className="fa-solid fa-circle-check"></i>

                  <p>હપ્તા ની સંખ્યા</p>
                  <h2
                    style={{
                      fontSize: "20px",
                      marginBottom: "5px",
                      fontWeight: "bold",
                    }}
                  >
                    120
                  </h2>
                </div>
              </div>

              <div className="loan-rate vehicle-rate">
                <span>વ્યાજ દર</span>
                <h2 style={{ marginBottom: "5px" }}>18%</h2>
              </div>

              <div className="loan-image">
                <img src="images/vehicleloan.webp" alt="" />
              </div>
            </div>

            <div className="loan-footer">
              સુરક્ષિત ♦ વિશ્વસનીય ♦ ઝડપી મંજૂરી ♦ ગ્રાહક પ્રથમ
            </div>
          </div>
        </div>
      </div>

      <div className="trust-section">
        <div className="trust-header12">
          <h2
            style={{
              fontSize: "40px",
              color: "#ffeb3b",
              fontWeight: "bold",
              marginBottom: "30px",
            }}
          >
            તો પછી રાહ શેની જુઓ છો , આવો અને સોસાયટી નાં શેર સભાસદ બનો.
          </h2>

          <p style={{ color: "#f5f8fc", fontWeight: "bold", fontSize: "18px" }}>
            દરેક યોજનાની વિસ્તૃત માહિતી તેમજ સોસાયટીમાં શેર સભાસદ થવા માટે બહેનો
            ઓફિસે કાર્યાલયમાં મેનેજરશ્રી ને ઓફિસ સમય દરમિયાન રૂબરૂ મળો.
          </p>

          <p style={{ color: "#f5f8fc", fontWeight: "bold", fontSize: "18px" }}>
            કામકાજ નો સમય: સોમ થી શનિ :- 10:00 થી 5:00
          </p>
          <p style={{ color: "#f5f8fc", fontWeight: "bold", fontSize: "18px" }}>
            બીજા તથા ચોથા શનિવારે રજા રહેશે.
          </p>
          <button
            style={{
              fontSize: "18px",
              background: "#ffeb3b",
              color: "#0a2c42",
              width: "200px",
            }}
            onClick={() => navigate("/join")}
          >
            સંપર્ક કરો
          </button>
        </div>

        <div className="modern-container"></div>
      </div>

      {/* TEAM */}
      <div className="team-section">
        <h2>અમારી ટીમ</h2>

        <div className="team-container">
          {team.length > 0 ? (
            team.map((member, index) => (
              <div className="team-card" key={index}>
                <div className="team-image">
                  <img src={`${BASE_URL}/uploads/${member.photo}`} alt="" />
                </div>
                <div className="team-text">
                  <h3>{member.name}</h3>
                  <p>{member.role}</p>
                </div>
              </div>
            ))
          ) : (
            <p>No team members found</p>
          )}
        </div>
      </div>
    </div>
  );
}
